import { Accessor, Component, Show } from 'solid-js';

import Logo from '@assets/logo.svg';
import Button from '@atoms/Button';
import { useTranslationState } from '@i18n/TranslationProvider';

export interface PageHeaderProps {
    userName: Accessor<string>;
    isLoggedIn: Accessor<boolean>;
    onLoginClicked: (event: MouseEvent) => void | unknown;
    onProfileClicked: (event: MouseEvent) => void | unknown;
    onJobsClicked: (event: MouseEvent) => void | unknown;
    onAboutClicked: (event: MouseEvent) => void | unknown;
    onCreateRoomClicked: (event: MouseEvent) => void | unknown;
    onJoinRoomClicked: (event: MouseEvent) => void | unknown;
}

const PageHeader: Component<PageHeaderProps> = (props) => {
    const t = useTranslationState().t;
    return (
        <div class="flex items-center h-20 p-5 bg-neutral-dark">
            <a href="/">
                <img src={Logo} class="flex-none" />
            </a>
            <div class="flex-1" />
        </div>
    );
};

export default PageHeader;
